import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { formatLocalString } from "../../utils/validation";
import { useLanguage } from '../../hooks/useLanguage';


function PackageReSelectPopup({ isPopup, setIsPopup, packageData, selectedProductSeqs, onSelectComplete, totalCnt }){
  const { t } = useLanguage();
  const location = useLocation();
  const [popupActive, setPopupActive] = useState();
  const [activeProductSeqs, setActiveProductSeqs] = useState([]);
  const [hoveredPackIndex, setHoveredPackIndex] = useState(null);
  const [checkedItems, setCheckedItems] = useState({});

  useEffect(() => {
    const body = document.body;
    body.style.overflow = isPopup ? 'hidden' : 'auto';
    return () => {
      body.style.overflow = 'auto';
    };
  }, [isPopup]);

  // 팝업 활성화 시 활성화 상태 변경
  useEffect(() => {
    let timeout;
    if (isPopup) {
      timeout = setTimeout(() => {
        setPopupActive(true);
      },100)
    } else {
      setPopupActive(false);
    }
    return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
    document.body.style.overflow = 'auto';
  }, [location]);

  useEffect(() => {
    if (isPopup && packageData && packageData.length > 0) {
      // 부모에서 전달받은 selectedProductSeqs를 그대로 사용
      // 빈 배열이 전달되면 빈 상태로, 값이 있으면 그 값을 사용
      // undefined나 null인 경우에만 default_flag='Y'를 사용
      const initialSelectedProductSeqs = selectedProductSeqs !== undefined && selectedProductSeqs !== null
        ? selectedProductSeqs 
        : packageData
            .filter(item => item.default_flag === 'Y')
            .map(item => item.product_seq);
      
      // activeProductSeqs를 현재 선택된 항목들로 초기화
      setActiveProductSeqs([...initialSelectedProductSeqs]);
      
      // 체크박스 상태도 함께 초기화 (product_seq 기반)
      const newCheckedItems = {};
      packageData.forEach((item, index) => {
        newCheckedItems[item.product_seq] = initialSelectedProductSeqs.includes(item.product_seq);
      });
      setCheckedItems(newCheckedItems);
    }
  }, [isPopup, packageData, selectedProductSeqs]);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);  // 팝업만 닫기
  };

  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };

  const handleItemClick = (productSeq) => {
    // activeProductSeqs 상태 토글
    setActiveProductSeqs(prev => {
      if (prev.includes(productSeq)) {
        return prev.filter(seq => seq !== productSeq);
      } else {
        return [...prev, productSeq];
      }
    });
    
    // 체크박스 상태 토글
    setCheckedItems(prev => ({
      ...prev,
      [productSeq]: !prev[productSeq]
    }));
  };
  
  // 초기화
  const handleReset = () => {
    setActiveProductSeqs([]); // activeProductSeqs 초기화
    
    // 체크박스 상태 초기화
    const resetCheckedItems = {};
    packageData.forEach(item => {
      resetCheckedItems[item.product_seq] = false;
    });
    setCheckedItems(resetCheckedItems);
  };

  // 원상복구 버튼 클릭 핸들러 수정
  const handleRestore = () => {
    // packageData에서 default_flag=Y인 아이템들의 product_seq로 복원
    const defaultSelectedProductSeqs = packageData
      .filter(item => item.default_flag === 'Y')
      .map(item => item.product_seq);
    
    setActiveProductSeqs([...defaultSelectedProductSeqs]);
    
    // 체크박스 상태도 함께 복원
    const restoredCheckedItems = {};
    packageData.forEach(item => {
      restoredCheckedItems[item.product_seq] = defaultSelectedProductSeqs.includes(item.product_seq);
    });
    setCheckedItems(restoredCheckedItems);
  };

  // 확인 버튼 클릭 핸들러
  const handleConfirm = () => {
    // 선택된 product_seq에 해당하는 상품 정보들을 추출하여 전달
    const selectedProductInfo = packageData
      .filter(item => activeProductSeqs.includes(item.product_seq))
      .map(item => ({
        product_seq: item.product_seq,
        bundle_ea: item.bundle_ea || 1,
        product_name: item.product_name
      }));
    
    
    setIsPopup(false);
    
    // product_seq 배열과 상품 정보를 함께 전달
    if (typeof onSelectComplete === 'function') {
      onSelectComplete(activeProductSeqs, selectedProductInfo);
    }
  };

  if (isPopup) 
    return(
      <div 
        className="popup-box-component"
        onClick={handleBackgroundClick}
      >
        <div className={`box content m ${popupActive ? 'active' : ''}`}>
          <div className="popup_container">
            <div className='close_btn_con'>
              <button 
                type="button" 
                className="close_btn"
                onClick={handleClose}
              />
            </div>
          

            <div className='detail_desc pop_desc'>
              <h3>{t('package_product')}</h3>
              <p className='b1_1'>{activeProductSeqs.length} <span className='g-70'> /{totalCnt}</span></p>
            </div>

            <p className='package_text b1_1 g-70'>{t('package_product_txt')}</p>

            <div>
              <ul className="pack_ul pack_pop">
                {packageData.map((item, index) => (
                  <li 
                    key={index} 
                    className={`pack_li ${activeProductSeqs.includes(item.product_seq) ? 'active' : ''}`}
                  >
                    <div
                      className='pack_list'
                      onMouseEnter={() => setHoveredPackIndex(index)}  
                      onMouseLeave={() => setHoveredPackIndex(null)}  
                    >
                      <div className="imgBox_56">
                        <div className="brand_img_sub">
                          <img src={item.brand_goods_img} alt="brand_goods_img" loading="lazy"/>
                        </div>
                        <div className="detail_img_sub">
                          <img src={item.goods_image[0]} alt="detail_img" loading="lazy"/>
                        </div>
                      </div>

                      <div style={{flex:'1'}}>
                        <p className="pack_name ellipsis_clamp">{item.package_goods_name}</p>
                      </div>

                      <div className='column flex-btw'>
                        <div 
                          className="default_chk_box"  
                          onMouseEnter={() => setHoveredPackIndex(null)}
                        >
                          <input 
                            type="checkbox" 
                            id={`product_${item.product_seq}`}
                            checked={checkedItems[item.product_seq] || false}
                            onChange={() => handleItemClick(item.product_seq)}
                          />
                          <label 
                            htmlFor={`product_${item.product_seq}`}
                            onClick={(e) => e.stopPropagation()} // 라벨 클릭 시 이벤트 전파 방지
                          />
                        </div>
                        <p className='g-70 m_12_l'>X{item.bundle_ea}</p>
                      </div>
                    </div>

                    {hoveredPackIndex === index && (
                      <div className="price_bubble">
                        <div className="day half">
                          <div className="day_hour_price">
                            <span className="hour">12h</span>
                            <span className="price">
                              <span className="price_won">₩</span>
                              {formatLocalString(item.result_12_price || 0)}
                            </span>
                          </div>
                          <div className="consumer_price">
                            <span className="consumer_price_won">₩</span>
                            <span className="line_through">
                              {formatLocalString(item.rental_12_price || 0)}
                            </span>
                          </div>
                        </div>
                        <div className="day">
                          <div className="day_hour_price">
                            <span className="hour">24h</span>
                            <span className="price">
                              <span className="price_won">₩</span>
                              {formatLocalString(item.result_24_price || 0)}
                            </span>
                          </div>
                          <div className="consumer_price">
                            <span className="consumer_price_won">₩</span>
                            <span className="line_through">
                              {formatLocalString(item.rental_24_price || 0)}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
              
            </div>


            <div className='pop_btn_wrap pack_btn'>
              <button
                type="button"
                className="default_btn yellow"
                onClick={handleConfirm}
              >
                {t('confirm')}
              </button>
              <button
                type="button"
                className="default_btn white"
                onClick={handleRestore}
              >
                {t('original_restore')}
              </button>
              <button
                type="button"
                className="default_btn white"
                onClick={handleReset}
              >
                {t('initialization')}
              </button>
            </div>

          </div>
        </div>

      </div>
    )
};

export default PackageReSelectPopup;